import { validateUrls } from "api/types"
import { getServiceURL } from "api/utils"
import { ServicePrefix } from "utils/constants"

const getCelestialURL = getServiceURL(ServicePrefix.celestial)
const getHadesURL = getServiceURL(ServicePrefix.hades)

export const urls = validateUrls({
  submissions: {
    retrieve: submissionId =>
      getCelestialURL(`/v1/assignments/submissions/${submissionId}`),

    listAssignmentUserSubmissions: (assignmentId, userId) =>
      getCelestialURL(
        `/v1/assignments/${assignmentId}/users/${userId}/submissions/`
      ),
  },

  users: {
    assessors: () => `/celestial/v1/centres/assessors/`,
  },

  plagiarism: {
    // Unprefixed on purpose: this Proxima route adds the source learners' names, which hades doesn't send
    getPlagiarisedSubmission: submissionId =>
      `/v1/submissions/${submissionId}/plagiarism/`,
    rerun: submissionId =>
      getHadesURL(`/v1/submissions/${submissionId}/plagiarism/rerun/`),
    grammarlyReport: submissionId =>
      getHadesURL(`/v1/submissions/${submissionId}/grammarly-report/`),
    // Unprefixed for the same reason: it includes the source learner's details
    getPlagiarismSources: (submissionId, sourceId) =>
      `/v1/submissions/${submissionId}/plagiarism-sources/${sourceId}/`,
  },
  aiContent: {
    getAiDetectedSubmission: submissionId =>
      getHadesURL(`/v1/submissions/${submissionId}/ai-detection/`),
    attachments: submissionId =>
      getHadesURL(`/v1/submissions/${submissionId}/attachments/`),
    rerun: submissionId =>
      getHadesURL(`/v1/submissions/${submissionId}/ai-detection/rerun/`),
  },
})
